import Link from 'components/Link'
import { articleCategoryPath } from 'libs/paths'
import type { getArticleCategories } from 'libs/server/api/articles'
import { trackCategoryListItemClicked } from '../events'
import { CategoryListItemImage } from './CategoryListItemImage'
import classes from './CategoryList.module.scss'

type ArticleCategory = Awaited<ReturnType<typeof getArticleCategories>>[number]

interface CategoryListItemProps {
  category: ArticleCategory
}

export const CategoryListItem = ({ category }: CategoryListItemProps) => (
  <div className='col-6 col-md-4' key={category.slug}>
    <Link
      className={`mc-h-100 mc-text--center d-block mc-py-8 mc-px-5 ${classes.category}`}
      href={articleCategoryPath(category.slug)}
      onClick={() => trackCategoryListItemClicked(category)}
    >
      <div className='d-none d-md-block'>
        <CategoryListItemImage category={category} />
      </div>
      <div className='d-block d-md-none'>
        <CategoryListItemImage category={category} ltMD />
      </div>
      <h3 className='mc-mt-4'>{category.name}</h3>
    </Link>
  </div>
)
